import { AxiosError } from "axios";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { BrandingTarget } from "types/landlord/address";
import { getErrorMessage } from "utils/error";

export type PropertyDictionary = ReturnType<
  typeof useUnitsPropertiesDictionary
>;

export const MAX_BRANDING_TARGETS = 200;

export const BRANDING_TARGETS_PER_PAGE =
  Number(window.localStorage.getItem("per_page")) || 10;

export const isPmsSynced = (target: BrandingTarget) =>
  Object.values(target.pms_synced_fields).some(Boolean);

export const getTargetName = (
  target: Pick<BrandingTarget, "name">,
  dictionary: PropertyDictionary
) => target.name || `Unnamed ${dictionary.property}`;

export const propertiesLabel = (
  count: number,
  dictionary: PropertyDictionary
) => (count === 1 ? dictionary.property : dictionary.properties);

export const getApplyErrorMessage = (
  error: unknown,
  dictionary: PropertyDictionary
) => {
  if (
    error instanceof AxiosError &&
    error.response?.data?.error?.code === "batch_size_exceeded"
  )
    return `You can apply branding to at most ${MAX_BRANDING_TARGETS} ${dictionary.properties} at a time.`;

  return getErrorMessage(error);
};
